import axios from 'axios'
import * as HttpStatus from 'http-status-codes'
import { PaginatedResults } from 'shared/helpers/typeHelper'

import { Equipment, EquipmentPayload, parseEquipment } from './equipment'

export enum TrailerType {
  DRY_VAN = 'DRY_VAN',
  FLATBED = 'FLATBED',
  REEFER = 'REEFER',
  OTHER = 'OTHER',
}

export interface Trailer extends Equipment {
  type?: TrailerType
  isInfoComplete?: boolean
  isBaseInfoComplete?: boolean
  isDocumentsComplete?: boolean
}

export interface TrailerPayload extends EquipmentPayload {
  type?: TrailerType
  is_info_complete?: boolean
  is_base_info_complete?: boolean
  is_documents_complete?: boolean
}

// Apis

export function createTrailer(payload: TrailerPayload): Promise<Trailer> {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }

  return axios.post(`/api/v1/trailers/`, payload.formData || payload, config).then((response) => {
    if (response.status === HttpStatus.CREATED) {
      return parseTrailer(response.data)
    }
    throw response.data
  })
}
export function fetchTrailers(page = 1): Promise<PaginatedResults<Trailer>> {
  return axios.get(`/api/v1/trailers/?page=${page}`).then((response) => {
    if (response.status === HttpStatus.OK) {
      return {
        ...response.data,
        results: response.data.results.map(parseTrailer),
      }
    }

    throw response.data
  })
}

export function fetchTrailer(id: string): Promise<Trailer> {
  return axios.get(`/api/v1/trailers/${id}/`).then((response) => {
    if (response.status === HttpStatus.OK) {
      return parseTrailer(response.data)
    }

    throw response.data
  })
}

export function updateTrailer(payload: TrailerPayload): Promise<Trailer> {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }

  return axios
    .patch(`/api/v1/trailers/${payload.id}/`, payload.formData || payload, config)
    .then((response) => {
      if (response.status === HttpStatus.OK) {
        return parseTrailer(response.data)
      }
      throw response.data
    })
}

export function deleteTrailer(trailerId: string) {
  return axios.delete(`/api/v1/trailers/${trailerId}/`)
}

export function parseTrailer(trailer: TrailerPayload): Trailer {
  return {
    ...parseEquipment(trailer),
    type: trailer.type,
    isInfoComplete: trailer.is_info_complete,
    isBaseInfoComplete: trailer.is_base_info_complete,
    isDocumentsComplete: trailer.is_documents_complete,
  }
}

// Helpers
export function getTrailerMissingFields(trailer: Trailer) {
  const errors = [!trailer.isBaseInfoComplete, !trailer.isDocumentsComplete].filter(Boolean)

  if (errors.length > 1) {
    return `Missing information`
  }

  if (!trailer.isBaseInfoComplete) {
    return 'Missing required information'
  }

  if (!trailer.isDocumentsComplete) {
    return 'Missing documents'
  }

  return ''
}
